import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "row mt-4 mb-2 font-weight-bold",
  style: {"font-size":"16px","text-decoration":"underline"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-6" }
const _hoisted_4 = { class: "d-block font-semi-bold mb-0 font-size color font-weight" }
const _hoisted_5 = { class: "font-weight margin-left color" }
const _hoisted_6 = { class: "col-6" }
const _hoisted_7 = { class: "d-block font-semi-bold mb-0 font-size color font-weight" }
const _hoisted_8 = { class: "font-weight margin-left color" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-6" }
const _hoisted_11 = { class: "d-block font-semi-bold mb-0 font-size color font-weight" }
const _hoisted_12 = { class: "col-6" }
const _hoisted_13 = { class: "d-block font-semi-bold mb-0 font-size color font-weight" }
const _hoisted_14 = { class: "font-weight margin-left color" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('demand.tabs.summary.client.label')), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('demand.tabs.summary.client.name')), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.clientName), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('demand.tabs.summary.client.phone')), 1),
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.clientPhone), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('demand.tabs.summary.client.mail')), 1),
        _createElementVNode("span", {
          class: "font-weight margin-left color text-primary",
          style: _normalizeStyle(_ctx.clientMail !='-' ? 'text-decoration: underline;' : null)
        }, _toDisplayString(_ctx.clientMail), 5)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('demand.tabs.summary.client.deliveryAdress')), 1),
        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.deliveryAdress), 1)
      ])
    ])
  ], 64))
}